import { Loader2 } from 'lucide-react';

/** Shown while a page's code loads (pages are loaded on demand). */
export const PageLoading = ({ fullScreen = false }: { fullScreen?: boolean }) => (
  <div role="status" aria-label="Loading"
       className={`flex items-center justify-center ${fullScreen ? 'min-h-screen' : 'min-h-[40vh]'}`}>
    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
  </div>
);
